<template>
  <div class="notif-modal bg-gray-50 dark:bg-gray-900">
    <div class="notif-head">Notification</div>
    <div class="notif-content">
      <div
        v-if="
          dataNotif === null
          || (dataNotif.length < 1 && (dataNotif.value && dataNotif.value.length < 1))
        "
        class="w-full h-full flex justify-center items-center"
      >
        No Notifications
      </div>

      <div
        v-else
        v-for="(data) in dataNotif.value"
        v-bind:key="data.id"
        @click="notifClick(data)"
        class="notif-value bg-white dark:bg-gray-700"
      >
        <div class="flex flex-nowrap gap-2">
          <div class="notif-icon"><icon :w="'w-6'" :h="'h-6'" :path="mdiEmail"/></div>
          <div class="notif-mail" >
            <div v-if="data.doc_name === 't_comboard_detail' || data.doc_name === 't_income_accrual' || data.doc_name === 't_payment' || data.doc_name === 't_assignment_score'">
              {{ data.info }}
            </div>
            <div v-else >
              {{ data.info }}
              <!-- <div v-if="data.state === 'Approved'">
                Permission dengan nama {{ data.doc_name}} telah di Approved dengan Permission Number {{ data.doc_number}}
              </div>
              <div v-else-if="data.state === 'Waiting for Approval'">
                Permission dengan nama {{ data.doc_name}} Sedang Waiting for Approval dengan Permission Number {{ data.doc_number}}
              </div> -->
            </div>
          </div>
        </div>

        <span class="notif-time">{{data.created_at}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  /*eslint-disable*/
  import { mdiEmail } from '@mdi/js'
  import { watchEffect, ref } from '@vue/runtime-core'
  import Icon from '@/components/Icon'
  import { useRouter } from 'vue-router'
  import axios from 'axios'

    export default {
    props: {
       propData: {
         type: Object,
         default: () => ({ empty: true })
       }
    },
    components: {
      Icon
    },
    data: function () {
        return {
        }
    },
    emit: ['notif-read', 'close-nav-notif'],
    setup (props,  { emit }) {

      const dataNotif = ref([])
      const router = useRouter()


      watchEffect(() => {
        dataNotif.value = props.propData
      })

      // const notifClick = (data) => {
      //   if (data.doc_name === 't_comboard_detail') {
      //     router.push('/comboard-dashboard')
      //   }
      //   else if ((data.doc_number === 'm_users') || (data.doc_name === 'm_users')) {
      //     console.log("cek data ges", data)

      //     localStorage.setItem('directNotif', JSON.stringify({ id: data.doc_id }))
      //     localStorage.setItem('isActiveModule', 'COURSE')
      //     localStorage.setItem('menu', 'COURSE')
      //     router.push('/completed-coursework')
      //   }
      //   else if (data.doc_name === 'tr_permission') {
      //     router.push('/permission/'+data.doc_id)
      //   }
      //   else if (data.doc_name === 'tr_hr_leave_approval') {
      //     router.push('/leave-request?leave='+data.doc_id)
      //   }
      //   else if (data.doc_name === 'tr_hr_over_time') {
      //     localStorage.setItem('directNotif', JSON.stringify({ id: data.doc_id }))
      //     router.push('/over-time')
      //   }
      //   else if (data.doc_name === 'tr_hr_over_time_detail') {
      //     localStorage.setItem('directNotif', JSON.stringify({ personal: true, id: data.doc_id }))
      //     router.push('/over-time-detail?personal=true')
      //   }
      //   else if (data.doc_name === 'tr_cocurricular') {
      //     localStorage.setItem('directNotif', JSON.stringify({ id: data.doc_id }))
      //     router.push({ path: '/tr-cocurricular', query: { notif: Date.now() } })
      //   }
      //   else{
      //     router.push('/notification/'+ data.id)
      //   }

      //   emit('close-nav-notif')
      // }

      const notifClick = (data) => {
        data.updated_by = localStorage.getItem('username')

        axios.post('klik-notif', data)
        .then((res) => {
          if (data.doc_name === 't_comboard_detail') {
            router.push('/comboard-dashboard')
          }
          else if ((data.doc_number === 'm_users') || (data.doc_name === 'm_users')) {
            console.log("cek data ges", data)

            localStorage.setItem('directNotif', JSON.stringify({ id: data.doc_id }))
            localStorage.setItem('isActiveModule', 'COURSE')
            localStorage.setItem('menu', 'COURSE')
            router.push('/completed-coursework')
          }
          else if (data.doc_name === 'tr_permission') {
            router.push('/permission/'+data.doc_id)
          }
          else if (data.doc_name === 'tr_hr_leave_approval') {
            router.push('/leave-request?leave='+data.doc_id)
          }
          else if (data.doc_name === 'tr_hr_over_time') {
            localStorage.setItem('directNotif', JSON.stringify({ id: data.doc_id }))
            router.push('/over-time')
          }
          else if (data.doc_name === 'tr_hr_over_time_detail') {
            localStorage.setItem('directNotif', JSON.stringify({ personal: true, id: data.doc_id }))
            router.push('/over-time-detail?personal=true')
          }
          else if (data.doc_name === 'tr_cocurricular') {
            localStorage.setItem('directNotif', JSON.stringify({ id: data.doc_id }))
            router.push({ path: '/tr-cocurricular', query: { notif: Date.now() } })
          }
          else{
            router.push('/notification/'+ data.id)
          }

          emit('close-nav-notif')
          emit('notif-read')
        })
        .catch((error) => {
          console.log(error)
        })
      }

      return {
        mdiEmail,
        dataNotif,
        notifClick
      }
    }
  }
</script>
